import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section footer-main">
          <h3>If you need it. We can print it.</h3>
          <p>
            If you don’t see it here, ask us. We will do the searching for you
            and the work to make sure it is compliant for iMR funding usage.
          </p>
          {/* <p>1.234.567.8900 &nbsp; | &nbsp; <a href="/">Home</a> &nbsp; | &nbsp; <a href="/terms">Terms and Conditions</a> &nbsp; | &nbsp; <a href="/legal">Legal</a></p> */}
          <p>Martin Advertising 2026. All rights reserved.</p>
        </div>
        <div className="footer-section footer-contact">
          <h4>Have Questions?</h4>
          <Link to="/contact" className="footer-contact-btn">Contact Us</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
